import { EvaluateTemplate } from '@/plugins/api'

export default {
  namespaced: true,

  state: {
    evaluateTemplates: [],
    totalEvaluateTemplates: 0,
    currentEvaluateTemplate: null,
  },

  mutations: {
    SET_EVALUATE_TEMPLATES(state, evaluateTemplates) {
      state.evaluateTemplates = evaluateTemplates
    },
    SET_TOTAL_EVALUATE_TEMPLATES(state, total) {
      state.totalEvaluateTemplates = total
    },
    SET_CURRENT_EVALUATE_TEMPLATE(state, evaluateTemplate) {
      state.currentEvaluateTemplate = evaluateTemplate
    },
    ADD_EVALUATE_TEMPLATE(state, evaluateTemplate) {
      if (Array.isArray(state.evaluateTemplates)) {
        state.evaluateTemplates.push(evaluateTemplate)
      } else {
        state.evaluateTemplates = [evaluateTemplate]
      }
    },
    UPDATE_EVALUATE_TEMPLATE(state, updatedEvaluateTemplate) {
      const index = state.evaluateTemplates.findIndex((et) => et.id === updatedEvaluateTemplate.id)
      if (index !== -1) {
        state.evaluateTemplates.splice(index, 1, updatedEvaluateTemplate)
      }
    },
    REMOVE_EVALUATE_TEMPLATE(state, id) {
      state.evaluateTemplates = state.evaluateTemplates.filter((et) => et.id !== id)
    },
  },

  actions: {
    async fetchEvaluateTemplates({ commit }, params) {
      try {
        const response = await EvaluateTemplate.fetch(params)
        commit('SET_EVALUATE_TEMPLATES', response)
        const countResponse = await EvaluateTemplate.count(params)
        commit('SET_TOTAL_EVALUATE_TEMPLATES', countResponse)
      } catch (error) {
        console.error('Error fetching evaluate templates:', error)
        throw error
      }
    },

    async fetchEvaluateTemplate({ commit }, id) {
      try {
        const response = await EvaluateTemplate.fetchOne(id)
        commit('SET_CURRENT_EVALUATE_TEMPLATE', response)
        return response
      } catch (error) {
        console.error('Error fetching evaluate template:', error)
        throw error
      }
    },

    async createEvaluateTemplate({ commit }, evaluateTemplate) {
      try {
        const response = await EvaluateTemplate.create(evaluateTemplate)
        commit('ADD_EVALUATE_TEMPLATE', response)
        return response
      } catch (error) {
        console.error('Error creating evaluate template:', error)
        throw error
      }
    },

    async updateEvaluateTemplate({ commit }, { id, data }) {
      try {
        const response = await EvaluateTemplate.update(id, data)
        commit('UPDATE_EVALUATE_TEMPLATE', response)
        return response
      } catch (error) {
        console.error('Error updating evaluate template:', error)
        throw error
      }
    },

    async deleteEvaluateTemplate({ commit }, id) {
      try {
        await EvaluateTemplate.remove(id)
        commit('REMOVE_EVALUATE_TEMPLATE', id)
      } catch (error) {
        console.error('Error deleting evaluate template:', error)
        throw error
      }
    },
  },

  getters: {
    getEvaluateTemplates: (state) => state.evaluateTemplates,
    getTotalEvaluateTemplates: (state) => state.totalEvaluateTemplates,
    getCurrentEvaluateTemplate: (state) => state.currentEvaluateTemplate,
  },
}
